module.exports = __webpack_public_path__ + "img/logout.28fb1927.svg";